var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsPlatformIconMiniapp = function SvgNewcsPlatformIconMiniapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_platform_icon_miniapp_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M861 553h18v18h-18z",
    "data-name": "\\u77E9\\u5F62 229"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_platform_icon_miniapp_svg__a)",
    transform: "translate(-861 -553)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#807997",
    d: "M870 555a7 7 0 1 0 7 7 7 7 0 0 0-7-7m3.51 6.292a2.08 2.08 0 0 1-1.194.9 1.2 1.2 0 0 1-.335.056.4.4 0 0 1 0-.8.2.2 0 0 0 .088-.017 1.25 1.25 0 0 0 .765-.56 1.03 1.03 0 0 0 .151-.542 1.23 1.23 0 0 0-1.285-1.143 1.44 1.44 0 0 0-.7.184 1.12 1.12 0 0 0-.6.963v3.339a1.89 1.89 0 0 1-1 1.646 2.17 2.17 0 0 1-1.091.28 2.03 2.03 0 0 1-2.1-1.941 1.87 1.87 0 0 1 .27-.955 2.08 2.08 0 0 1 1.195-.9 1.2 1.2 0 0 1 .334-.056.4.4 0 1 1 .005.795h-.001a.2.2 0 0 0-.088.017 1.3 1.3 0 0 0-.764.56 1.03 1.03 0 0 0-.152.542 1.23 1.23 0 0 0 1.3 1.146 1.43 1.43 0 0 0 .7-.183 1.12 1.12 0 0 0 .6-.963v-3.323a1.9 1.9 0 0 1 .992-1.648 2.1 2.1 0 0 1 1.08-.294 2.03 2.03 0 0 1 2.1 1.942 1.86 1.86 0 0 1-.27.955",
    "data-name": "\\u8DEF\\u5F84 492"
  }))));
};
export default SvgNewcsPlatformIconMiniapp;